"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.greedyWidthNativelySupported = undefined;

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.findDirectChildByTagName = findDirectChildByTagName;
exports.findDirectChildByClassName = findDirectChildByClassName;
exports.sumArray = sumArray;
exports.columnCount = columnCount;
exports.columnData = columnData;
exports.getColumnWidths = getColumnWidths;
exports.generateWidthStyle = generateWidthStyle;
exports.getAllKeySetOfTree = getAllKeySetOfTree;
exports.getAllExpandableKeySetOfTree = getAllExpandableKeySetOfTree;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Column = require("./Column");

var _Column2 = _interopRequireDefault(_Column);

var _ColumnGroup = require("./ColumnGroup");

var _ColumnGroup2 = _interopRequireDefault(_ColumnGroup);

var _bowser = require("bowser");

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findDirectChildByTagName(parent, tagName) {
    return Array.prototype.find.call(parent.childNodes, function (n) {
        return n.nodeName == tagName.toUpperCase();
    }) || null;
}

function findDirectChildByClassName(parent, className) {
    return Array.prototype.find.call(parent.childNodes, function (n) {
        return n.classList.contains(className);
    }) || null;
}

function sumArray(src) {
    return src.reduce(function (lhs, rhs) {
        return lhs + rhs;
    }, 0);
}

function columnCount_(child) {
    if (child.type == _Column2.default) {
        return 1;
    } else if (child.type == _ColumnGroup2.default) {
        return sumArray(_react2.default.Children.map(child.props.children, columnCount_));
    } else {
        return 0;
    }
}

function columnCount(children) {
    return sumArray(_react2.default.Children.map(children, columnCount_));
}

function columnData_(child) {
    if (child.type == _Column2.default) {
        return [{
            maxWidth: child.props.maxWidth,
            minWidth: child.props.minWidth,
            width: child.props.width,
            getCellProps: child.props.getCellProps
        }];
    } else if (child.type == _ColumnGroup2.default) {
        return Array.prototype.concat.apply([], _react2.default.Children.toArray(child.props.children).map(columnData_));
    } else {
        return [];
    }
}

function columnData(children) {
    return Array.prototype.concat.apply([], _react2.default.Children.toArray(children).map(columnData_));
}

function getColumnWidths(table, n) {
    var tr = document.createElement("tr");
    tr.className = "cn-table-col-width-test";
    for (var i = 0; i < n; i++) {
        tr.appendChild(document.createElement("td"));
    }
    table.tBodies[0].appendChild(tr);
    // offsetWidth or clientWidth?
    // neither ... use getBoundingClientRect() so we can have the fraction part
    var ret = Array.prototype.map.call(tr.childNodes,
    // n => n.offsetWidth);
    function (n) {
        return n.getBoundingClientRect().width;
    });
    table.tBodies[0].removeChild(tr);
    return ret;
}

function generateWidthStyle(props) {
    var style = {};
    if (props.maxWidth) {
        style.maxWidth = props.maxWidth;
    }
    if (props.minWidth) {
        style.minWidth = props.minWidth;
    }
    if (props.width) {
        style.width = props.width;
        style.minWidth = props.width;
        style.maxWidth = props.width;
    }
    return style;
}

var greedyWidthNativelySupported = exports.greedyWidthNativelySupported = function () {
    // caniuse.com/#search=max-content Can I use... Support tables for HTML5, CSS3, etc
    var data = [[{ chrome: "46" }, "max-content"], [{ chrome: "22" }, "-webkit-max-content"], [{ firefox: "3" }, "-moz-max-content"], [{ safari: "6.1" }, "-webkit-max-content"], [{ opera: "33" }, "max-content"], [{ opera: "15" }, "-webkit-max-content"]];
    return data.reduce(function (pv, _ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            cvCond = _ref2[0],
            cvRet = _ref2[1];

        return pv || _bowser2.default.check(cvCond, true) && cvRet;
    }, false);
}();

function getAllKeySetOfTree(data, pk) {
    var ret = new _set2.default();
    function visit(node) {
        if (typeof node[pk] != "undefined" && node[pk] !== null) {
            ret.add(node[pk]);
        }
        Array.isArray(node.children) && node.children.forEach(visit);
    }
    if (Array.isArray(data)) {
        data.forEach(visit);
    }
    return ret;
}

function getAllExpandableKeySetOfTree(data, pk) {
    var ret = new _set2.default();
    function visit(node) {
        if (Array.isArray(node.children) && typeof node[pk] != "undefined" && node[pk] !== null) {
            ret.add(node[pk]);
        }
        Array.isArray(node.children) && node.children.forEach(visit);
    }
    if (Array.isArray(data)) {
        data.forEach(visit);
    }
    return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/column-utils.js
// module id = 280
// module chunks = 0